module.exports = __webpack_public_path__ + "static/img/teleservice11.7e838fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teleservice11.jpg
// module id = x0po
// module chunks = 0